<div class="modal-window-container fx-cover fx-center-all" #container (click)="allowCloseWindow && closeWindow()">
    <div class="modal-window-inner" [class]="customClass" #window>
        <iframe #upgradeDialogFrame [src]="upgradeDialogUrl | safe" class="upgrade-dialog-window-iframe" allow="clipboard-write"></iframe>
    </div>
</div>




